(() => {
  let owner = null;
  let version = 0;
  let refreshOnRestore = false;
  let departed = false;
  const expressState = new Map();
  const controlsSelector =
    'cart-items :is(input,button,select), cart-drawer :is(input,button,select), pm-cart-addons :is(button,select), product-form :is(input,button,select), variant-selects :is(input,button,select), pm-pdp-bestsellers :is(button,select), [name="checkout"]';

  function busy(input) {
    return Boolean(
      departed ||
      owner ||
      window.PrepMeCartMutation ||
      document.querySelector(".cart__items--disabled, product-form .loading") ||
      [...document.querySelectorAll('input[name="updates[]"]')].some(
        (quantity) =>
          quantity !== input &&
          quantity.value !== quantity.getAttribute("value"),
      ),
    );
  }

  function lock(input) {
    // Publication happens under the lock: subscribers may read, never re-enter a write.
    if (busy(input)) return null;
    const token = {};
    owner = token;
    version++;
    window.PrepMeCartMutation = true;
    const controls = [...document.querySelectorAll(controlsSelector)].map(
      (control) => [control, control.disabled],
    );
    controls.forEach(([control]) => {
      control.disabled = true;
    });
    token.restore = () => {
      controls.forEach(([control, disabled]) => {
        if (control.isConnected) control.disabled = control.pmVariantDisabled ?? disabled;
      });
    };
    sync();
    return () => {
      if (owner !== token || token.leftPage) return;
      owner = null;
      window.PrepMeCartMutation = false;
      token.restore();
      sync();
    };
  }

  function restoreExpress() {
    expressState.forEach((inert, element) => {
      if (element.isConnected) element.inert = inert;
    });
    expressState.clear();
  }

  function sync() {
    if (busy()) {
      document.querySelectorAll(".prepme-express-checkout").forEach((element) => {
        if (!expressState.has(element)) expressState.set(element, element.inert);
        element.inert = true;
      });
    } else {
      restoreExpress();
      document.querySelectorAll('product-form [type="submit"], product-form button[name="add"]').forEach((control) => {
        if (typeof control.pmVariantDisabled === 'boolean') control.disabled = control.pmVariantDisabled;
      });
    }
    document.dispatchEvent(new CustomEvent("pm:cart-mutations-changed"));
  }

  window.PrepMeCartMutations = Object.freeze({
    busy,
    lock,
    sync,
    get version() {
      return version;
    },
  });
  document.addEventListener(
    "submit",
    (event) => {
      if (
        busy() &&
        event.target.matches(
          '#cart, #CartDrawer-Form, form[action$="/cart/add"], form[action$="/cart/add.js"]',
        )
      )
        event.preventDefault();
    },
    true,
  );
  document.addEventListener(
    "click",
    (event) => {
      if (busy() && event.target.closest(".prepme-express-checkout")) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
  document.addEventListener("input", (event) => {
    if (event.target.matches('input[name="updates[]"]')) sync();
  });
  window.addEventListener("pagehide", () => {
    refreshOnRestore = busy();
    departed = true;
    if (owner) {
      owner.leftPage = true;
      owner.restore();
    }
    restoreExpress();
    document.querySelectorAll('input[name="updates[]"]').forEach((input) => {
      input.value = input.getAttribute("value");
    });
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted && (owner || refreshOnRestore)) window.location.reload();
    else if (event.persisted) {
      departed = false;
      sync();
    }
  });
  if (typeof MutationObserver === "function") {
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some(
        (node) => node.nodeType === 1 &&
          (node.matches(".prepme-express-checkout") || node.querySelector(".prepme-express-checkout")),
      )) && busy()) sync();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
